import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getDirectsConsortiumGroupFilesCount = (directID, tcID) => {
  return axios.get(
    `/api/directs/${directID}/consortium_groups/${tcID}/files/count`
  );
};

export const useDirectsConsortiumGroupFilesCount = (directID, tcID, options = {}) => {
  return useQuery(
    `direct-consortium-group-${tcID}-count`,
    () => getDirectsConsortiumGroupFilesCount(directID, tcID),
    {
      //@ts-ignore
      initialData: { data: { count: 0 } },
      select: ({ data }) => data,
      ...options,
    }
  );
}
